import React from 'react'
import ActionButton from 'uiComponents/buttons'
import { Col, Row } from 'uiComponents/flex'
import { ModalDialogTitle } from 'uiComponents/popups/modal'
import { Headline } from 'uiComponents/typography'
import { DiscountPool } from 'discounts/types'
import { removeHash, setHash } from 'utils/hash'

interface AddPoolSuccessfulProps {
    pool?: DiscountPool
}

const AddPoolSuccessful: React.FC<AddPoolSuccessfulProps> = ({ pool }) => {
    const addDiscounts = () => {
        setHash('add_discount', { poolUuid: pool?.uuid ?? '' })
    }

    return (
        <>
            <ModalDialogTitle>Pool successfully added!</ModalDialogTitle>
            <Headline size={6} style={{ wordBreak: 'break-word' }}>
                You have successfully added discount code pool{pool?.name && <b>&nbsp;&quot;{pool.name}&quot;</b>}. Add
                discounts or upload .csv file with discount codes now!
            </Headline>
            <Row align="flex-end" style={{ paddingTop: '32px' }}>
                <Col span="auto">
                    <ActionButton size="large" secondary onClick={removeHash}>
                        Cancel
                    </ActionButton>
                </Col>
                <Col span="auto">
                    <ActionButton size="large" onClick={addDiscounts}>
                        Add discounts
                    </ActionButton>
                </Col>
            </Row>
        </>
    )
}

export default AddPoolSuccessful
